import {Box, Group, Loader, Tooltip} from "@mantine/core";
import {
  IconBooks,
  IconLayoutDashboard,
  IconSettings,
  IconUser,
} from "@tabler/icons-react";
import {Link, Outlet, useLocation} from "@tanstack/react-router";
import {LogoutButton} from "@/app/auth";
import {useSync} from "@/app/storage";
import {ColorSchemeToggle} from "@/app/ui/ColorSchemeToggle";
import styles from "./styles.module.css";

export function ShellLayout() {
  const {isSyncing} = useSync();
  const location = useLocation();

  const links = [
    {label: "Home", icon: IconLayoutDashboard, to: "/dashboard"},
    {label: "Library", icon: IconBooks, to: "/library"},
    {label: "Profile", icon: IconUser, to: "/profile"},
    {label: "Settings", icon: IconSettings, to: "/settings"},
  ];

  const desktopLinks = links.map(link => (
    <Link
      key={link.label}
      to={link.to}
      className={styles.desktopLink}
      data-active={location.pathname === link.to || undefined}
    >
      {link.label}
    </Link>
  ));

  const mobileLinks = links.map(link => {
    const Icon = link.icon;
    return (
      <Link
        key={link.label}
        to={link.to}
        className={styles.navLink}
        data-active={location.pathname === link.to || undefined}
      >
        <Icon size={24} stroke={1.5} />
        <span className={styles.navLinkText}>{link.label}</span>
      </Link>
    );
  });

  return (
    <Box>
      <header className={styles.header}>
        <Group>
          <Link to="/" className={styles.logo}>
            atarashii
          </Link>
          <nav className={styles.desktopNav}>{desktopLinks}</nav>
        </Group>

        <Group gap="xs" wrap="nowrap">
          {isSyncing && (
            <Tooltip label="Syncing with PDS...">
              <Loader size="xs" color="teal" />
            </Tooltip>
          )}
          <ColorSchemeToggle />
          <LogoutButton variant="subtle" size="sm" />
        </Group>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>{mobileLinks}</footer>
    </Box>
  );
}
